/* =====================================================================================================================
   MJP EXCLUSIVE - interazioni della sezione sections/mjp-exclusive.liquid
   Copertina (parallax, conto alla rovescia), aggiunta rapida dalle card, Spotlight, barra fissa mobile,
   altri prodotti della griglia allo scorrimento o con pulsante (stessa sezione, pagina successiva).
   Nessuna libreria, nessuna richiesta esterna: solo /cart/add.js del negozio.
   ===================================================================================================================== */
(function () {
  'use strict';
  /* Ogni sezione Exclusive include questo file: si esegue una volta sola */
  if (window.__mjxLoaded) return;
  window.__mjxLoaded = true;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function qs(el, s) { return el.querySelector(s); }
  function qsa(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }
  function json(el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } }

  /* ---------- Carrello: stesso giro di mjp-giftbox-dialog (drawer di app esterna o del tema) ---------- */
  function addToCart(id, props) {
    var item = { id: id, quantity: 1 };
    if (props && Object.keys(props).length) item.properties = props;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(item)
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw new Error(d && (d.description || d.message) || 'cart'); return d; });
    });
  }
  function openDrawer() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    var d = document.querySelector('cart-drawer');
    setTimeout(function () {
      if (d && typeof d.show === 'function') d.show();
      else document.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: {} }));
    }, 120);
  }

  function init(root) {
    if (root.dataset.mjxBound) return;
    root.dataset.mjxBound = '1';
    var T = {
      added: root.dataset.tAdded || 'Aggiunto al carrello',
      error: root.dataset.tError || 'Non e\' stato possibile aggiungere. Riprova.',
      soldout: root.dataset.tSoldout || 'Esaurito'
    };

    /* Avviso */
    var toast = document.createElement('div');
    toast.className = 'mjx-toast'; toast.setAttribute('role', 'status'); toast.setAttribute('aria-live', 'polite');
    root.appendChild(toast);
    var toastTmr = null;
    function say(msg) {
      toast.textContent = msg; toast.classList.add('is-on');
      clearTimeout(toastTmr); toastTmr = setTimeout(function () { toast.classList.remove('is-on'); }, 2200);
    }

    /* ---------- Copertina ---------- */
    var hero = qs(root, '[data-mjx-hero]');
    if (hero) {
      /* Banner piu' in basso nella pagina (data-mjx-inview): il titolo entra quando il banner arriva in vista */
      if (hero.hasAttribute('data-mjx-inview') && 'IntersectionObserver' in window) {
        var heroIo = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) { hero.classList.add('is-in'); heroIo.disconnect(); }
        }, { threshold: 0.2 });
        heroIo.observe(hero);
      } else {
        requestAnimationFrame(function () { requestAnimationFrame(function () { hero.classList.add('is-in'); }); });
      }
      var media = qs(hero, '.mjx-hero__media');
      if (media && !REDUCED && hero.hasAttribute('data-parallax')) {
        var ticking = false;
        var onScroll = function () {
          if (ticking) return; ticking = true;
          requestAnimationFrame(function () {
            var r = hero.getBoundingClientRect();
            if (r.bottom > 0 && r.top < window.innerHeight) media.style.transform = 'translate3d(0,' + (Math.max(0, -r.top) * 0.22).toFixed(1) + 'px,0)';
            ticking = false;
          });
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }

      /* Video: si scarica solo quello adatto allo schermo; la foto resta finche' il video non parte.
         Con "riduci animazioni" o risparmio dati resta la foto. */
      var vid = qs(hero, '[data-mjx-video]');
      if (vid) {
        var saveData = navigator.connection && navigator.connection.saveData;
        var mq = window.matchMedia('(max-width: 699px)');
        var loadVid = function () {
          var src = mq.matches ? vid.getAttribute('data-src-m') : vid.getAttribute('data-src-d');
          if (!src) { vid.removeAttribute('src'); vid.classList.remove('is-playing'); return; }
          if (vid.getAttribute('src') === src) return;
          vid.classList.remove('is-playing');
          vid.src = src;
          vid.muted = true;
          var p = vid.play();
          if (p && p.catch) p.catch(function () {});
        };
        vid.addEventListener('playing', function () { vid.classList.add('is-playing'); });
        if (!REDUCED && !saveData) {
          loadVid();
          if (mq.addEventListener) mq.addEventListener('change', loadVid);
          if ('IntersectionObserver' in window) {
            new IntersectionObserver(function (en) {
              if (!vid.getAttribute('src')) return;
              if (en[0].isIntersecting) { var p2 = vid.play(); if (p2 && p2.catch) p2.catch(function () {}); } else { vid.pause(); }
            }).observe(hero);
          }
        }
      }
    }

    /* Numero dei pezzi in copertina: lo stesso della barra prodotti, che non conta i prodotti esclusi (es. Mystery Box) */
    qsa(root, '[data-mjx-count]').forEach(function (el) {
      var src = document.querySelector('[data-mjx-count-src]');
      if (src && src.textContent.trim()) el.textContent = src.textContent.trim();
    });

    /* Conto alla rovescia (data-mjx-cd = timestamp ms). Finito il tempo, il chip sparisce. */
    qsa(root, '[data-mjx-cd]').forEach(function (el) {
      var end = parseInt(el.getAttribute('data-mjx-cd'), 10), chip = el.closest('.mjx-chip');
      if (!end || isNaN(end)) { if (chip) chip.hidden = true; return; }
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var s = Math.floor((end - Date.now()) / 1000);
        if (s <= 0) { if (chip) chip.hidden = true; return false; }
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        el.textContent = (d > 0 ? d + 'g ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
        return true;
      }
      if (tick()) { if (chip) chip.hidden = false; var iv = setInterval(function () { if (!tick()) clearInterval(iv); }, 1000); }
    });

    /* Ordina */
    var sort = qs(root, '[data-mjx-sort]');
    if (sort) sort.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      u.searchParams.delete('page');
      u.hash = 'mjx-grid';
      window.location.href = u.toString();
    });

    /* ---------- Comparsa ---------- */
    var io = null;
    if ('IntersectionObserver' in window && !REDUCED) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target, i = parseInt(el.dataset.mjxIndex || '0', 10) % 4;
          el.style.transitionDelay = (i * 60) + 'ms';
          el.classList.add('is-in');
          io.unobserve(el);
          setTimeout(function () { el.style.transitionDelay = ''; }, 900);
        });
      }, { rootMargin: '0px 0px -8% 0px' });
    }
    function reveal(els) { els.forEach(function (el) { if (io) io.observe(el); else el.classList.add('is-in'); }); }
    reveal(qsa(root, '[data-mjx-reveal]'));

    /* Inclinazione leggera della card in evidenza (solo mouse) */
    if (!REDUCED && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      qsa(root, '[data-mjx-tilt]').forEach(function (card) {
        var media = qs(card, '.mjx-card__media');
        if (!media) return;
        media.classList.add('mjx-tilt');
        card.addEventListener('pointermove', function (e) {
          var r = media.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
          media.style.transform = 'perspective(900px) rotateY(' + (x * 5).toFixed(2) + 'deg) rotateX(' + (-y * 5).toFixed(2) + 'deg)';
        });
        card.addEventListener('pointerleave', function () { media.style.transform = ''; });
      });
    }

    /* ---------- Aggiunta rapida dalle card ---------- */
    function pillsHTML(vs, selectedId) {
      return vs.map(function (v) {
        return '<button type="button" class="mjx-pill' + (v.id === selectedId ? ' is-on' : '') + '" data-id="' + v.id + '"' + (v.a ? '' : ' disabled aria-disabled="true"') + '>' +
          String(v.t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }) + '</button>';
      }).join('');
    }

    /* Velo dietro il pannello varianti su mobile (sotto i 640px il pannello sale dal fondo dello schermo) */
    var scrim = document.createElement('div');
    scrim.className = 'mjx-scrim'; scrim.setAttribute('aria-hidden', 'true');
    root.appendChild(scrim);
    var SMALL = window.matchMedia('(max-width: 639px)');
    scrim.addEventListener('click', function () { closeSheets(); });

    function closeSheets(except) {
      qsa(root, '.mjx-card.is-sheet').forEach(function (c) {
        if (c === except) return;
        c.classList.remove('is-sheet');
        var b = qs(c, '[data-mjx-qa]'); if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!except) { scrim.classList.remove('is-on'); root.classList.remove('is-sheet-open'); }
    }

    function done(btn) {
      btn.classList.remove('is-busy'); btn.classList.add('is-done');
      setTimeout(function () { btn.classList.remove('is-done'); }, 1600);
    }

    function bindCard(card) {
      var btn = qs(card, '[data-mjx-qa]'), data = qs(card, '[data-mjx-variants]');
      if (!btn || !data) return;
      var vs = json(data) || [];
      var sheet = qs(card, '.mjx-sheet'), list = sheet && qs(sheet, '.mjx-pills'), msg = sheet && qs(sheet, '.mjx-sheet__msg');

      function add(v) {
        if (btn.classList.contains('is-busy')) return;
        btn.classList.add('is-busy'); if (msg) msg.hidden = true;
        addToCart(v.id, v.props).then(function () {
          done(btn); closeSheets(); say(T.added); openDrawer();
        }).catch(function (err) {
          btn.classList.remove('is-busy');
          if (msg) { msg.textContent = (err && err.message && err.message !== 'cart') ? err.message : T.error; msg.hidden = false; }
          else say(T.error);
        });
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var avail = vs.filter(function (v) { return v.a; });
        if (!avail.length) { say(T.soldout); return; }
        if (vs.length === 1) { add(vs[0]); return; }
        var open = !card.classList.contains('is-sheet');
        closeSheets(card);
        card.classList.toggle('is-sheet', open);
        scrim.classList.toggle('is-on', open && SMALL.matches);
        root.classList.toggle('is-sheet-open', open && SMALL.matches);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open && list && !list.childElementCount) list.innerHTML = pillsHTML(vs, null);
        if (open && list) { var first = qs(list, '.mjx-pill:not([disabled])'); if (first) first.focus({ preventScroll: true }); }
      });

      if (list) list.addEventListener('click', function (e) {
        var p = e.target.closest('.mjx-pill');
        if (!p || p.disabled) return;
        var id = parseInt(p.dataset.id, 10);
        var v = vs.filter(function (x) { return x.id === id; })[0];
        if (v) { qsa(list, '.mjx-pill').forEach(function (x) { x.classList.toggle('is-on', x === p); }); add(v); }
      });
      var x = sheet && qs(sheet, '.mjx-sheet__x');
      if (x) x.addEventListener('click', function () { closeSheets(); btn.focus({ preventScroll: true }); });
    }
    qsa(root, '.mjx-card').forEach(bindCard);

    /* ---------- Altri prodotti: pagina successiva della stessa sezione, aggiunta in coda alla griglia ----------
       Le pagine fatte solo di prodotti esclusi (es. Mystery Box) vengono saltate: niente pagine vuote. */
    var more = qs(root, '[data-mjx-more]'), grid = qs(root, '[data-mjx-grid]');
    if (more && grid && window.fetch && window.DOMParser) {
      var next = more.dataset.next, sid = more.dataset.section, auto = more.dataset.mode === 'infinite';
      var moreBtn = qs(more, '[data-mjx-more-btn]'), busy = false, mio = null;
      var pages = qs(root, '[data-mjx-pages]');
      if (pages) pages.hidden = true;
      more.hidden = false;
      var finish = function () { if (mio) mio.disconnect(); more.remove(); };
      var load = function () {
        if (busy || !next) return;
        busy = true; more.classList.add('is-busy'); more.classList.remove('is-error');
        var u = new URL(next, window.location.origin);
        u.searchParams.set('section_id', sid);
        fetch(u.toString(), { credentials: 'same-origin' }).then(function (r) {
          if (!r.ok) throw new Error('page');
          return r.text();
        }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var g = doc.querySelector('[data-mjx-grid]'), m = doc.querySelector('[data-mjx-more]');
          var cards = g ? Array.prototype.slice.call(g.children) : [];
          cards.forEach(function (c) { grid.appendChild(document.importNode(c, true)); });
          var added = Array.prototype.slice.call(grid.children).slice(-cards.length);
          if (cards.length) { added.forEach(function (c) { if (c.classList.contains('mjx-card')) bindCard(c); }); reveal(added); }
          next = m ? m.dataset.next : '';
          busy = false; more.classList.remove('is-busy');
          if (!next) { finish(); return; }
          if (!cards.length) { load(); return; }
          /* Se la fine della griglia e' ancora a vista, l'osservatore deve ripartire */
          if (mio) { mio.unobserve(more); mio.observe(more); }
        }).catch(function () {
          busy = false; more.classList.remove('is-busy'); more.classList.add('is-error');
        });
      };
      if (moreBtn) moreBtn.addEventListener('click', load);
      if (auto && 'IntersectionObserver' in window) {
        mio = new IntersectionObserver(function (en) { if (en[0].isIntersecting) load(); }, { rootMargin: '0px 0px 700px 0px' });
        mio.observe(more);
      }
    }
    document.addEventListener('click', function (e) { if (!e.target.closest('.mjx-card') && !e.target.closest('.mjx-scrim')) closeSheets(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheets(); });

    /* ---------- Spotlight ---------- */
    qsa(root, '[data-mjx-spot]').forEach(function (spot) {
      var imgs = qsa(spot, '.mjx-spot__main img'), thumbs = qsa(spot, '.mjx-spot__thumb');
      function show(i) {
        imgs.forEach(function (im, j) { im.classList.toggle('is-on', j === i); });
        thumbs.forEach(function (t, j) { t.classList.toggle('is-on', j === i); t.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });

    });

    /* ---------- Acquisto diretto: Spotlight e Mystery Box ([data-mjx-buy] = pillole + pulsante) ---------- */
    qsa(root, '[data-mjx-buy]').forEach(function (box) {
      var data = qs(box, '[data-mjx-variants]'), vs = data ? (json(data) || []) : [];
      var pills = qs(box, '.mjx-pills'), atc = qs(box, '[data-mjx-add]'), price = qs(box, '[data-mjx-price]');
      if (!atc) return;
      var label = qs(atc, '[data-label]'), labelDefault = label ? label.textContent : '';
      var chosen = null;
      var avail = vs.filter(function (v) { return v.a; });
      if (vs.length === 1 && vs[0].a) chosen = vs[0];
      if (pills && vs.length > 1) pills.innerHTML = pillsHTML(vs, null);
      function sync() {
        atc.disabled = (!chosen && vs.length > 1) ? false : !(chosen && chosen.a);
        if (!avail.length) { atc.disabled = true; if (label) label.textContent = T.soldout; }
        if (chosen && price) price.textContent = chosen.p;
      }
      sync();
      if (pills) pills.addEventListener('click', function (e) {
        var p = e.target.closest('.mjx-pill');
        if (!p || p.disabled) return;
        var id = parseInt(p.dataset.id, 10);
        chosen = vs.filter(function (x) { return x.id === id; })[0] || null;
        qsa(pills, '.mjx-pill').forEach(function (x) { x.classList.toggle('is-on', x === p); });
        if (label) label.textContent = labelDefault;
        sync();
      });
      atc.addEventListener('click', function () {
        if (!chosen) {
          if (label) label.textContent = box.dataset.tChoose || labelDefault;
          if (pills && pills.animate && !REDUCED) pills.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 320 });
          return;
        }
        atc.disabled = true;
        addToCart(chosen.id, chosen.props).then(function () {
          atc.classList.add('is-done'); if (label) label.textContent = T.added;
          say(T.added); openDrawer();
          setTimeout(function () { atc.classList.remove('is-done'); if (label) label.textContent = labelDefault; sync(); }, 1800);
        }).catch(function (err) {
          say((err && err.message && err.message !== 'cart') ? err.message : T.error); sync();
        });
      });
    });

    /* ---------- Packaging: punti numerati sull'immagine <-> voci dell'elenco ---------- */
    qsa(root, '[data-mjx-pkg]').forEach(function (pkg) {
      var pins = qsa(pkg, '[data-pkg-pin]'), rows = qsa(pkg, '[data-pkg-row]');
      function pick(i) {
        pins.forEach(function (p) { var on = p.dataset.pkgPin === i; p.classList.toggle('is-on', on); p.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        rows.forEach(function (r) { r.classList.toggle('is-on', r.dataset.pkgRow === i); });
      }
      pins.forEach(function (p) { p.addEventListener('click', function () { pick(p.dataset.pkgPin); }); });
      rows.forEach(function (r) {
        r.addEventListener('mouseenter', function () { pick(r.dataset.pkgRow); });
        r.addEventListener('click', function () { pick(r.dataset.pkgRow); });
      });
      /* Apri la scelta confezione della scheda prodotto (snippets/mjp-giftbox-dialog.liquid), se c'e' */
      qsa(pkg, '[data-pkg-open]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          var row = document.querySelector('[data-mgbx-open]');
          if (row) { row.click(); return; }
          var buy = document.querySelector('.mjp__buy-buttons, .mjp__info');
          if (buy) buy.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' });
        });
      });
    });

    /* ---------- Barra fissa mobile: dopo la copertina, fino alla fine della sezione ---------- */
    /* La copertina e la griglia sono sezioni diverse: la fine e' il segnaposto in fondo ai prodotti, o il footer */
    var sticky = qs(root, '[data-mjx-sticky]');
    var ends = qsa(document, '[data-mjx-end]'), end = ends[ends.length - 1] || document.querySelector('footer, .shopify-section-group-footer-group');
    if (sticky && hero && 'IntersectionObserver' in window) {
      var heroOut = false, endIn = false;
      var paint = function () { sticky.classList.toggle('is-on', heroOut && !endIn); };
      new IntersectionObserver(function (en) { heroOut = !en[0].isIntersecting; paint(); }).observe(hero);
      if (end) new IntersectionObserver(function (en) { endIn = en[0].isIntersecting; paint(); }).observe(end);
    }
  }

  function boot() { qsa(document, '[data-mjx-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    /* Una sezione puo' avere piu' radici (MJP Exclusive - Banner: una per banner) */
    if (e.target && e.target.querySelectorAll) qsa(e.target, '[data-mjx-root]').forEach(init);
  });
})();
